export default __webpack_public_path__ + "static/media/4.c81ffbd1.jpg";